import {
  determineAssekuranztarifFromTarifbereich,
  KommDaten,
  KommDatenEmail,
} from '@ps20-frontend/frontend-models';
import { Tarifbereich } from '@ps20/bff-models';
import { IAppState } from '../localStore';

export const selectVersicherungsnehmerEmail = (state: IAppState): KommDatenEmail => {
  return state.versicherungsnehmer.email;
};

export const selectVersicherungsnehmerEmailIsNullOrEmpty = (state: IAppState): boolean => {
  return (
    state.versicherungsnehmer.email.wert == null || state.versicherungsnehmer.email.wert === ''
  );
};

export const selectVersicherungsnehmerMobilnummer = (state: IAppState): KommDaten => {
  return state.versicherungsnehmer.mobil;
};

export const selectVersicherungsnehmerMobilnummerIsNullOrEmpty = (state: IAppState): boolean => {
  return (
    state.versicherungsnehmer.mobil.wert == null || state.versicherungsnehmer.mobil.wert === ''
  );
};

export const isAssekuranzTarif = (state: IAppState): boolean =>
  determineAssekuranztarifFromTarifbereich(state.versicherungsnehmer.tarifbereich);

export const selectTarifBereich = (state: IAppState): Tarifbereich =>
  state.versicherungsnehmer.tarifbereich;

export const selectVersicherungsnehmerMobilWert = (state: IAppState): string =>
  selectWert(state.versicherungsnehmer.mobil.wert);

export const selectVersicherungsnehmerTelefonWert = (state: IAppState): string =>
  selectWert(state.versicherungsnehmer.telefon.wert);

export const selectProgrammteilnahmeResponseReceived = (state: IAppState): boolean =>
  Boolean(state.transientState.programmteilnahmeResponseReceived);

const selectWert = (value: string): string => {
  if (!value) {
    return '';
  } else if (value.startsWith('0049/') || value.startsWith('0049 ')) {
    return value.replace(/^.{5}/g, '+49');
  } else if (value.startsWith('00')) {
    return value.replace(/^.{2}/g, '+');
  }
  return value;
};
